import React from 'react';
import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Skeleton } from '@material-ui/lab';
import TicketImage from './TicketImage';
import { useTicketImageContainerStyles } from './styles';

const TicketImageContainer = ({ ...props }) => {
  const { thumbnailImage, isMkp } = props;

  const classes = useTicketImageContainerStyles();
  return (
    <Box>
      <Box>
        {!thumbnailImage && <Skeleton className={classes.skeleton} />}
        {thumbnailImage && (
          <TicketImage thumbnailImage={thumbnailImage} isMkp={isMkp} />
        )}
      </Box>
    </Box>
  );
};

TicketImageContainer.propTypes = {
  thumbnailImage: PropTypes.string,
  isMkp: PropTypes.bool,
};

export default TicketImageContainer;
